const normalizeComparable = (value) => String(value ?? '').trim().toLowerCase();
const isSet = (value) => value !== null && value !== undefined && String(value).trim() !== '';

const getByPath = (source, path) => String(path || '')
  .replace(/\[(\d+)\]/g, '.$1')
  .split('.')
  .filter(Boolean)
  .reduce((value, key) => value?.[key], source);

const evaluateCondition = (condition, root) => {
  const actual = getByPath(root, condition.sourcePath);
  const normalizedActual = normalizeComparable(actual);
  switch (condition.operator) {
    case 'equals': return normalizedActual === normalizeComparable(condition.value);
    case 'notEquals': return normalizedActual !== normalizeComparable(condition.value);
    case 'in': return (condition.values || []).some(value => normalizedActual === normalizeComparable(value));
    case 'notIn': return (condition.values || []).every(value => normalizedActual !== normalizeComparable(value));
    case 'isSet': return isSet(actual);
    case 'isNotSet': return !isSet(actual);
    default: return false;
  }
};

export const evaluateRequirementRules = (rules, root) => Boolean(rules?.any?.some(group => (
  group.all?.length > 0 && group.all.every(condition => evaluateCondition(condition, root))
)));

export const isFieldEffectivelyRequired = (field, root) => {
  if (field.requirementRules) return evaluateRequirementRules(field.requirementRules, root);
  if (field.dependsOnSourcePath) {
    return normalizeComparable(getByPath(root, field.dependsOnSourcePath))
      === normalizeComparable(field.dependsOnValue);
  }
  return Boolean(field.isRequired);
};

export const getSimpleEqualityCondition = (field) => {
  if (!field.requirementRules) {
    return field.dependsOnSourcePath
      ? { sourcePath: field.dependsOnSourcePath, operator: 'equals', value: field.dependsOnValue }
      : null;
  }
  const groups = field.requirementRules.any || [];
  return groups.length === 1 && groups[0].all?.length === 1 && groups[0].all[0].operator === 'equals'
    ? groups[0].all[0]
    : null;
};